import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=0a5e1d0e&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=0a5e1d0e&prod&lang=scss&scoped=true"
import style1 from "./Coupons.vue?vue&type=style&index=1&id=0a5e1d0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e1d0e",
  null
  
)

export default component.exports